const PLAYER_SIZES = {
	sm: { w: 120, h: 75 },
	md: { w: 180, h: 115 },
	lg: { w: 220, h: 140 },
} as const;

interface GhostPlayerProps {
	size?: keyof typeof PLAYER_SIZES;
	rotation?: number;
	opacity?: number;
	progressFill?: number;
	className?: string;
	style?: React.CSSProperties;
}

export function GhostPlayer({
	size = "md",
	rotation = 0,
	opacity = 0.04,
	progressFill = 0.35,
	className,
	style,
}: GhostPlayerProps) {
	const { w, h } = PLAYER_SIZES[size];
	const barY = h - 14;
	const barPad = 10;
	const barW = w - barPad * 2;

	return (
		<div
			aria-hidden="true"
			className={className}
			style={{
				position: "absolute",
				pointerEvents: "none",
				width: w,
				height: h,
				opacity,
				animation: "ghost-float 20s ease-in-out infinite",
				["--ghost-r" as string]: `${rotation}deg`,
				transform: `rotate(${rotation}deg)`,
				...style,
			}}
		>
			<svg
				aria-hidden="true"
				width={w}
				height={h}
				viewBox={`0 0 ${w} ${h}`}
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				{/* Player frame */}
				<rect
					x="1"
					y="1"
					width={w - 2}
					height={h - 2}
					rx={12}
					stroke="#FF0000"
					strokeWidth="1.5"
					fill="rgba(255,0,0,0.02)"
				/>

				{/* Play triangle (centered) */}
				<polygon
					points={`${w / 2 - 8},${h / 2 - 12} ${w / 2 + 10},${h / 2} ${w / 2 - 8},${h / 2 + 12}`}
					fill="rgba(255,0,0,0.15)"
				/>

				{/* Progress bar track */}
				<rect
					x={barPad}
					y={barY}
					width={barW}
					height={4}
					rx={2}
					fill="rgba(0,0,0,0.06)"
				/>

				{/* Progress bar fill */}
				<rect
					x={barPad}
					y={barY}
					width={barW * progressFill}
					height={4}
					rx={2}
					fill="rgba(255,0,0,0.2)"
				/>

				{/* Control dots */}
				<circle cx={barPad + 4} cy={barY - 8} r={2} fill="rgba(0,0,0,0.06)" />
				<circle cx={barPad + 14} cy={barY - 8} r={2} fill="rgba(0,0,0,0.06)" />
			</svg>
		</div>
	);
}
